import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M27.1284 11.6914L16 22.6914L27.1284 33.6914",
      stroke: "#401D42",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }